function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "_4409095001594941304",
  "data-name": 4409095001594941400,
  transform: "translate(2.753 2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9070",
  "data-name": "Path 9070",
  d: "M3,36.748,9.418,26.38A20.121,20.121,0,0,1,26.2,17H42.5a9.9,9.9,0,0,1-9.874,9.874H27.685",
  transform: "translate(-3 20.027)",
  fill: "none",
  stroke: "#00b2ae",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9071",
  "data-name": "Path 9071",
  d: "M28.216,26.874H47.964l2.962-3.95A14.73,14.73,0,0,1,62.774,17h0L56.11,28.849A20.044,20.044,0,0,1,38.584,39.216h0A58.8,58.8,0,0,0,6,49.09H6",
  transform: "translate(1.405 20.027)",
  fill: "none",
  stroke: "#00b2ae",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3858",
  "data-name": "Rectangle 3858",
  width: 52.582,
  height: 29.577,
  transform: "translate(5.799 0)",
  fill: "none",
  stroke: "#00b2ae",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9072",
  "data-name": "Path 9072",
  d: "M32.874,11.874A9.9,9.9,0,0,1,23,2",
  transform: "translate(26.369 -2)",
  fill: "none",
  stroke: "#00b2ae",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9073",
  "data-name": "Path 9073",
  d: "M5,10a9.9,9.9,0,0,1,9.874,9.874",
  transform: "translate(-0.063 9.748)",
  fill: "none",
  stroke: "#00b2ae",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_354",
  "data-name": "Ellipse 354",
  cx: 7.668,
  cy: 7.668,
  r: 7.668,
  transform: "translate(24.422 7.668)",
  fill: "none",
  stroke: "#00b2ae",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9074",
  "data-name": "Path 9074",
  d: "M14.874,2A9.9,9.9,0,0,1,5,11.874",
  transform: "translate(-0.063 -2)",
  fill: "none",
  stroke: "#00b2ae",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9075",
  "data-name": "Path 9075",
  d: "M32.874,10A9.9,9.9,0,0,0,23,19.874",
  transform: "translate(26.369 9.748)",
  fill: "none",
  stroke: "#00b2ae",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}));

function SvgSuccessfulTopUpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.933,
    height: 73.89,
    viewBox: "0 0 68.933 73.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfulTopUpIcon);
export default __webpack_public_path__ + "static/media/successful-top-up-icon.152edbc6.svg";
export { ForwardRef as ReactComponent };